const DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/;

// Portuguese is the app's primary language, so it is also the fallback.
function localeFor(language: string | null | undefined): string {
  return language && !language.startsWith('pt') ? 'en-US' : 'pt-BR';
}

/**
 * A plan-card moment in short numeric form, with the year:
 * - a calendar day (YYYY-MM-DD, e.g. a PIX due date) → "12/11/2026" (pt) /
 *   "11/12/2026" (en), never shifted by the viewer's time zone;
 * - an instant (ISO) → "12/11/2026, 09:00" / "11/12/2026, 09:00 AM" in the
 *   viewer's time zone (or `timeZone`).
 */
export function formatPlanMoment(
  value: string,
  language: string | null | undefined,
  timeZone?: string,
): string {
  const locale = localeFor(language);
  const dateOnly = DATE_ONLY.exec(value);
  if (dateOnly) {
    const date = new Date(Date.UTC(Number(dateOnly[1]), Number(dateOnly[2]) - 1, Number(dateOnly[3])));
    return new Intl.DateTimeFormat(locale, {
      day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'UTC',
    }).format(date);
  }
  return new Intl.DateTimeFormat(locale, {
    day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZone,
  }).format(new Date(value));
}
